// Uncomment the next line for importing the log utility
// import { getLogger } from 'loglevel';

export default class PostsSlider {
  constructor() {
    // The selector that identifies the main element that this script is attached to.
    this.selector = '.c-posts-slider';
  }

  // eslint-disable-next-line class-methods-use-this
  bootstrap() {
    const components = document.querySelectorAll(this.selector);

    components.forEach(component => {
      const slider = component.querySelector('.c-posts-slider__slider');

      const flkty = new Flickity(slider, {
        wrapAround: true,
        cellAlign: 'left',
        pageDots: false,
        adaptiveHeight: false,
        prevNextButtons: false
      });

      // add button handlers
      const btnPrev = slider.parentNode.querySelector('.c-posts-slider__nav--prev');
      const btnNext = slider.parentNode.querySelector('.c-posts-slider__nav--next');

      btnPrev.addEventListener('click', event => {
        event.preventDefault();
        flkty.previous( true, false );
      });

      btnNext.addEventListener('click', event => {
        event.preventDefault();
        flkty.next( true, false );
      });

    });
  }
}
